import { render, staticRenderFns } from "./SoilEntry.vue?vue&type=template&id=98574352&scoped=true"
import script from "./SoilEntry.vue?vue&type=script&lang=js"
export * from "./SoilEntry.vue?vue&type=script&lang=js"
import style0 from "./SoilEntry.vue?vue&type=style&index=0&id=98574352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98574352",
  null
  
)

export default component.exports